import React from 'react';
import { Skeleton } from '@shared/components/Skeleton';
import { Box, Flex, SpacingStack } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { CREATE_WEDDING_CONTAINER_MAX_WIDTH } from '@apps/acquisitionFunnels/createWedding/components/CreateWeddingLayout/CreateWeddingLayout';
import { useTranslation } from '@shared/core';

const BORDER_RADIUS = 2;

export const CreateWeddingPlaceholder: React.FC = () => {
  const { tq } = useTranslation('createWedding');
  return (
    <Flex
      width="100%"
      maxWidth={{ _: '100%', sm2: pxToRem(CREATE_WEDDING_CONTAINER_MAX_WIDTH) }}
      flexDirection="column"
      alignItems="center"
      gap={5}
      role="status"
      aria-busy="true"
      aria-label={tq`Loading form`}
    >
      <Skeleton
        height={pxToRem(42)}
        width={pxToRem(67)}
        borderRadius={BORDER_RADIUS}
      />

      <SpacingStack
        spacing={5}
        width="100%"
        alignItems="center"
        marginTop={5}
      >
        <Skeleton
          height={pxToRem(34)}
          width="80%"
          borderRadius={BORDER_RADIUS}
        />
        <Skeleton
          height={pxToRem(16)}
          width="60%"
          borderRadius={BORDER_RADIUS}
        />
      </SpacingStack>

      <SpacingStack
        spacing={6}
        width="100%"
        marginTop={2}
      >
        <SpacingStack spacing={2}>
          <Box height={pxToRem(14)} />
          <Skeleton
            height={pxToRem(50)}
            width="100%"
            borderRadius={BORDER_RADIUS}
          />
        </SpacingStack>

        <SpacingStack spacing={2}>
          <Box height={pxToRem(14)} />
          <Skeleton
            height={pxToRem(50)}
            width="100%"
            borderRadius={BORDER_RADIUS}
          />
        </SpacingStack>

        <SpacingStack spacing={5}>
          <SpacingStack spacing={2}>
            <Box height={pxToRem(14)} />
            <Skeleton
              height={pxToRem(56)}
              width="100%"
              borderRadius={BORDER_RADIUS}
            />
          </SpacingStack>
          <Flex
            gap={3}
            flexDirection="row"
            alignItems="center"
          >
            <Skeleton
              height={pxToRem(20)}
              width={pxToRem(36)}
              borderRadius={pxToRem(12)}
            />
            <Skeleton
              height={pxToRem(14)}
              width={pxToRem(190)}
              borderRadius={BORDER_RADIUS}
            />
          </Flex>
        </SpacingStack>

        <SpacingStack spacing={5}>
          <SpacingStack spacing={2}>
            <Box height={pxToRem(14)} />
            <Skeleton
              height={pxToRem(56)}
              width="100%"
              borderRadius={BORDER_RADIUS}
            />
          </SpacingStack>
          <Flex
            gap={3}
            flexDirection="row"
            alignItems="center"
          >
            <Skeleton
              height={pxToRem(20)}
              width={pxToRem(36)}
              borderRadius={pxToRem(12)}
            />
            <Skeleton
              height={pxToRem(14)}
              width={pxToRem(210)}
              borderRadius={BORDER_RADIUS}
            />
          </Flex>
        </SpacingStack>
      </SpacingStack>

      <SpacingStack
        spacing={6}
        width="100%"
        marginTop={6}
        alignItems="center"
      >
        <Skeleton
          height={pxToRem(52)}
          width="100%"
          borderRadius={pxToRem(28)}
        />
        <Skeleton
          height={pxToRem(18)}
          width="70%"
          borderRadius={BORDER_RADIUS}
        />
      </SpacingStack>
    </Flex>
  );
};
